import { accent } from "../hooks/tokens.js";
import { ARTICLES } from "../data.js";

// Révision espacée (boîtes de Leitner) : file du jour, carte courante,
// notation, tableau de bord de toutes les fiches.
export function buildReviseView(ctx) {
  const { s, patch, go, syncBox, dueLabel } = ctx;
  const boxOf = (id) => s.boxes[id] || 1;
  const due = ARTICLES.filter((a) => s.reviseForce || boxOf(a.id) <= 2);
  const queue = due.slice().sort((a, b) => boxOf(a.id) - boxOf(b.id));
  const card = queue[0];
  const mastered = ARTICLES.filter((a) => boxOf(a.id) >= 4).length;
  const grade = (id, next) => () => {
    patch({ boxes: { ...s.boxes, [id]: next }, cardFlipped: false, reviseSeen: s.reviseSeen + 1 });
    syncBox(id, next);
  };

  return {
    reviseActive: !!card, reviseEmpty: !card,
    reviseDue: due.length ? due.length + " carte" + (due.length > 1 ? "s" : "") + " en attente." : "File vide.",
    reviseStats: [
      { value: String(due.length), label: "à revoir", color: accent },
      { value: String(s.reviseSeen), label: "vues aujourd'hui", color: "oklch(0.3 0.015 60)" },
      { value: String(mastered), label: "acquises", color: "oklch(0.3 0.015 60)" },
    ],
    cardDomain: card ? card.domain : "", cardBox: card ? "Palier " + boxOf(card.id) + " / 5" : "",
    cardFront: card ? "Que faut-il retenir de « " + card.title + " » ?" : "",
    cardBack: card ? card.summary : "", cardSnippet: card ? card.snippet : "",
    cardOpen: () => { if (card) go(card.id); },
    cardFlipped: s.cardFlipped && !!card, cardHidden: !s.cardFlipped && !!card,
    flipCard: () => patch({ cardFlipped: true }),
    grades: card ? [
      { label: "À revoir", next: 1, border: "oklch(0.86 0.04 30)", color: "oklch(0.45 0.06 30)" },
      { label: "Correct", next: Math.min(5, boxOf(card.id) + 1), border: "oklch(0.9 0.01 85)", color: "oklch(0.35 0.015 60)" },
      { label: "Facile", next: Math.min(5, boxOf(card.id) + 2), border: accent, color: accent },
    ].map((g) => ({ ...g, onClick: grade(card.id, g.next) })) : [],
    reviseHint: card ? "Palier " + boxOf(card.id) + " → prochaine échéance " + dueLabel(Math.min(5, boxOf(card.id) + 1)) : "",
    reviseNext: "Prochaine échéance : " + dueLabel(3) + ". Les cartes remontent seules dans la file.",
    resetRevise: () => patch({ reviseForce: true, cardFlipped: false }),
    deckRows: ARTICLES.map((a) => ({ title: a.title,
      pips: [1, 2, 3, 4, 5].map((i) => ({ bg: i <= boxOf(a.id) ? accent : "oklch(0.93 0.008 85)" })),
      due: dueLabel(boxOf(a.id)),
      dueColor: boxOf(a.id) <= 2 ? accent : "oklch(0.56 0.015 60)" })),
  };
}
